var moduleMap = {
	"./Root": () => {
		return Promise.all([__webpack_require__.e(40724), __webpack_require__.e(41271), __webpack_require__.e(44914), __webpack_require__.e(59676), __webpack_require__.e(86672), __webpack_require__.e(9354), __webpack_require__.e(40244), __webpack_require__.e(668), __webpack_require__.e(25712), __webpack_require__.e(63034)]).then(() => (() => ((__webpack_require__(52254)))));
	},
	"./ContactBar": () => {
		return Promise.all([__webpack_require__.e(40724), __webpack_require__.e(41271), __webpack_require__.e(44914), __webpack_require__.e(59676), __webpack_require__.e(86672), __webpack_require__.e(9354), __webpack_require__.e(40244), __webpack_require__.e(668), __webpack_require__.e(25712), __webpack_require__.e(31667)]).then(() => (() => ((__webpack_require__(76208)))));
	},
	"./ContactSettings": () => {
		return Promise.all([__webpack_require__.e(40724), __webpack_require__.e(41271), __webpack_require__.e(47767), __webpack_require__.e(87527), __webpack_require__.e(48175), __webpack_require__.e(44914), __webpack_require__.e(59676), __webpack_require__.e(86672), __webpack_require__.e(9354), __webpack_require__.e(40244), __webpack_require__.e(31051), __webpack_require__.e(53258)]).then(() => (() => ((__webpack_require__(53258)))));
	},
	"./ContactList": () => {
		return Promise.all([__webpack_require__.e(40724), __webpack_require__.e(41271), __webpack_require__.e(47767), __webpack_require__.e(87527), __webpack_require__.e(48175), __webpack_require__.e(44914), __webpack_require__.e(59676), __webpack_require__.e(86672), __webpack_require__.e(9354), __webpack_require__.e(40244), __webpack_require__.e(668), __webpack_require__.e(31051), __webpack_require__.e(14673)]).then(() => (() => ((__webpack_require__(14673)))));
	},
	"./ContactListNew": () => {
		return Promise.all([__webpack_require__.e(40724), __webpack_require__.e(41271), __webpack_require__.e(44914), __webpack_require__.e(59676), __webpack_require__.e(86672), __webpack_require__.e(9354), __webpack_require__.e(40244), __webpack_require__.e(56636)]).then(() => (() => ((__webpack_require__(56636)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});